import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ImpressumSection from '../components/ImpressumSection';

const ImpressumPage = () => {
  useEffect(() => {
    // Scrolle beim Laden der Seite nach oben
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <ImpressumSection />
      <Footer />
    </>
  );
};

export default ImpressumPage;